const getMissingDocumentsStatus = {
  true: 'DOCUMENTOS DO COLABORADOR FALTANTES: ',
  false: 'DOCUMENTOS DA EMPRESA FALTANTES: '
};

export default getMissingDocumentsStatus;
